import syilfirmBenefits from "../../../../src/content/treatments/sylfirmx-rf-microneedling-skin-tightening/sylfirmx-benefits.jpg";
import * as React from 'react';
export default {
  syilfirmBenefits,
  React
};